import {
	type ClientPortfolioCryptocurrenciesInstructionRequestDTO,
	type ClientPortfolioCryptocurrencyInstructionResponseDTO,
	ClientPortfolioInvestmentTypeEnum,
	CurrencyEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { DEFAULT_INSTRUCTION_CURRENCY } from "web_myplann/Portfolio/Forms/ToolsShared/constants";
import type { InstructionInput } from "web_myplann/Portfolio/Forms/ToolsShared/instructionSchema";
import { isEnumValue } from "web_myplann/Shared/Utils/parsers";

type InstructionFormValues = {
	id: number | null;
	investmentType: ClientPortfolioInvestmentTypeEnum | null;
	date: string | null;
	endedAt: string | null;
	amount: number | null;
	currency: CurrencyEnum;
	frequency:
		| ClientPortfolioCryptocurrencyInstructionResponseDTO["frequency"]
		| null;
	count: number | null;
};

export const mapCryptoInstructionToRequest = (
	instruction: InstructionFormValues,
	cryptocurrencyCode: string,
): ClientPortfolioCryptocurrenciesInstructionRequestDTO => {
	const isSell =
		instruction.investmentType === ClientPortfolioInvestmentTypeEnum.Sell;

	return {
		id: instruction.id,
		investmentType: instruction.investmentType,
		currencyFrom: isSell ? cryptocurrencyCode : instruction.currency,
		countFrom: isSell ? instruction.count : instruction.amount,
		currencyTo: isSell ? instruction.currency : cryptocurrencyCode,
		countTo: isSell ? instruction.amount : instruction.count,
		frequency: instruction.frequency,
		date: instruction.date,
		endedAt: instruction.endedAt,
	};
};

export const mapCryptoInstructionToForm = (
	instruction: ClientPortfolioCryptocurrencyInstructionResponseDTO,
): InstructionInput & { count: number | null } => {
	const isSell =
		instruction.investmentType === ClientPortfolioInvestmentTypeEnum.Sell;
	const currency = isSell ? instruction.currencyTo : instruction.currencyFrom;

	return {
		id: instruction.id,
		investmentType:
			instruction.investmentType ?? ClientPortfolioInvestmentTypeEnum.Buy,
		date: parseIsoDate(instruction.date),
		endedAt: parseIsoDate(instruction.endedAt),
		amount: isSell
			? (instruction.countTo ?? null)
			: (instruction.countFrom ?? null),
		currency: isEnumValue(CurrencyEnum, currency)
			? currency
			: DEFAULT_INSTRUCTION_CURRENCY,
		frequency: instruction.frequency,
		count: isSell
			? (instruction.countFrom ?? null)
			: (instruction.countTo ?? null),
	};
};
